import React from 'react';
import PropTypes from 'prop-types';

export default function PlusIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 15.12 15.12'>
      <path
        fill={fill}
        d='M14.121 6.563H8.558V.998a1 1 0 0 0-1.995 0v5.565H.998a1 1 0 0 0 0 1.995h5.565v5.565a1 1 0 0 0 1.995 0V8.558h5.565a1 1 0 1 0 0-1.995Z'
        data-name='Caminho 21915'
      />
    </svg>
  );
}

PlusIcon.defaultProps = {
  size: '20',
  fill: '#41a152'
};

PlusIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
